export default __webpack_public_path__ + "static/hdmi_xr_adapter-8435f9a8b735b3f9b3078ca536cb63e4.png";